import { useQuery } from "@tanstack/react-query"

import { getFoodOrderTracking } from "@/lib/food/foodPaymentService"

export function useFoodTracking(foodOrderId: string | undefined) {
  return useQuery({
    queryKey: ['food-tracking', foodOrderId],
    queryFn: foodOrderId ? ({signal}) => getFoodOrderTracking({foodOrderId, signal}) : skipToken,
    throwOnError: false,
    placeholderData: keepPreviousData,
    refetchOnMount: true,
    refetchInterval: ({state: {data}}) => {
      if (!['completed', 'canceled'].includes(data?.status ?? '')) {
        return 5000
      }
      return false
    },
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
}
